import { render, staticRenderFns } from "./ConjugeSV.vue?vue&type=template&id=0cfe523a&"
import script from "./ConjugeSV.vue?vue&type=script&lang=js&"
export * from "./ConjugeSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports